// @ts-nocheck
import { debounce } from '@theme/utilities';

/**
 * A custom element that displays a drawer.
 */

class CustomDrawer extends HTMLElement {
  constructor() {
    super();

    // Only drawers actually nested inside .header-wrapper (the header's
    // menu and country-selector drawers) get reparented to <body> -
    // .header-wrapper is position: sticky; z-index: 50 !important, a
    // stacking context that traps anything inside it below higher
    // z-index content elsewhere on the page (e.g. the product gallery
    // lightbox, z-index: 200) no matter how high the drawer's own
    // z-index is set. Reparenting after Liquid has already rendered the
    // markup doesn't touch any section/settings scoping the render
    // depended on.
    //
    // This must stay scoped to .header-wrapper specifically, not applied
    // to every drawer unconditionally - other drawers elsewhere on the
    // page (e.g. the collection filters drawer) rely on staying inside
    // their normal .shopify-section ancestor; facets.js's sectionId
    // getter throws without one, breaking filtering entirely.
    if (this.closest('.header-wrapper')) {
      document.body.appendChild(this);
    }

    this.openButtons = [
  ...new Set([
    ...document.querySelectorAll(`[${this.getAttribute('data-trigger')}]`),
    ...this.querySelectorAll('[data-trigger]')
  ])
];

    this.overlay = document.querySelector('#drawer-overlay');
    this.closeButtons = this.querySelectorAll(
      '[close-drawer-button]'
    );

    this.openButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.openDrawer(e);
      });
    })

    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.closeDrawer();
      });
    }

    this.closeButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          this.closeDrawer(e);
      }) 
    });

    this.spacing = this.getAttribute('data-top-spacing');

    if(this.spacing){
        this.getAnnouncementBarHeight();

        let lastWidth = document.body.clientWidth;

        const ro = new ResizeObserver(
          debounce(entries => {
            // @ts-ignore
            const newWidth = entries[0].contentRect.width;

            if (newWidth !== lastWidth) {
              lastWidth = newWidth;
              this.getAnnouncementBarHeight();
            }
          }, 10)
        );
    }
  }

  getAnnouncementBarHeight() {
    const bar = document.querySelector('.announcement-bar');
    // @ts-ignore
    const height = bar ? bar.offsetHeight : 0;
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;

    if(scrollY <= 1){
        document.documentElement.setAttribute('show-announcement', '');
        document.documentElement.style.setProperty(
            '--announcement-bar-height',
            `${height}px`
        )
    }else{
        document.documentElement.style.setProperty(
            '--announcement-bar-height',
            `0px`
        );
    }
  }

  openDrawer(e) {
    if (this.spacing) {
      this.getAnnouncementBarHeight();
    }

    const triggerEl = e?.target?.closest('[data-trigger]');
    const trigger = triggerEl?.getAttribute('data-trigger');

    const targetDrawer = trigger
      ? document.querySelector(`custom-drawer[data-trigger='${trigger}']`)
      : this;

    if (!targetDrawer) return;

    const currentOpen = document.querySelector('custom-drawer[drawer-open]');

    if (currentOpen && currentOpen !== targetDrawer) {
      previousDrawer = currentOpen;
      currentOpen.removeAttribute('drawer-open');
    }

    document.documentElement.setAttribute('scroll-lock', '');
    document.documentElement.setAttribute('drawer-open', '');
    targetDrawer.setAttribute('drawer-open', '');

    // Set active tab if trigger button has data-active-tab-index
    const activeTabIndex = triggerEl?.getAttribute('data-active-tab-index');
    if (activeTabIndex) {
      const drawerTabs = targetDrawer.querySelector('drawer-tabs');
      if (drawerTabs) {
        drawerTabs.setActive(parseInt(activeTabIndex));
      }
    }
  }

  closeDrawer(e) {
    const backTrigger = e?.target?.closest('[open-previous-drawer]');

    if (backTrigger && previousDrawer) {
      this.removeAttribute('drawer-open');

      previousDrawer.setAttribute('drawer-open', '');
      previousDrawer = null;

      return;
    }

    // Closing a drawer that was opened from inside the gallery lightbox
    // (e.g. the AI tag drawer) shouldn't unlock scroll - the gallery is
    // still open underneath and needs the lock to stay in place.
    if (!document.querySelector('.product-gallery-slider.open')) {
      document.documentElement.removeAttribute('scroll-lock');
    }
    document.documentElement.removeAttribute('drawer-open');
    this.removeAttribute('drawer-open');

    setTimeout(() => {
      document.documentElement.removeAttribute('show-announcement');
    }, 200);
  }
}

if (!customElements.get('custom-drawer')) {
  customElements.define('custom-drawer', CustomDrawer);
}

document.addEventListener('keydown', (e) => closeDrawer(e));

/**
 * @param {KeyboardEvent} e
 */
function closeDrawer(e){
  if (e.key === 'Escape') {
    // Same as CustomDrawer.closeDrawer() - keep the lock while the gallery
    // lightbox is still open underneath.
    if (!document.querySelector('.product-gallery-slider.open')) {
      document.documentElement.removeAttribute('scroll-lock');
    }
    document.documentElement.removeAttribute('drawer-open');

    document.querySelectorAll('.drawer[drawer-open]').forEach(drawer => {
      drawer.removeAttribute('drawer-open');
    })
  }
}
